<template>
  <kye-drawer title="主题外观设置" :visible.sync="visible" :modal="false" :appendToBody="true"
    customClass="theme-setting-drawer" size="500px" direction="rtl" class="layout-theme-setting">
    <div class="theme-setting-drawer__header" slot="title">
      <span>主题外观设置</span>
    </div>
    <div class="theme-setting-drawer__body kye-scrollbar">
      <div class="theme-setting-drawer__body-item">
        <div class="theme-setting-drawer__body-item-title">外观模式</div>
        <appearance-mode v-model="currentMode" />
      </div>
      <div class="theme-setting-drawer__body-item">
        <div class="theme-setting-drawer__body-item-title">主题色</div>
        <kye-radio-group v-model="themeRadio" style="width: 100%;">
          <div class="theme-color-container">
            <div class="theme-color-item" v-for="theme in builtinThemes" :key="theme.value" :class="{ 'actived': theme.value === themeRadio }" @click="changeThemeRadio(theme.value)">
              <div class="theme-color-radio">
                <!-- <kye-radio :label="theme.value">{{theme.label}}{{ currentMode === 'light' && theme.value === defaultConfig.skinsCode ? '(默认)' : ''  }}{{ theme.isEyeCare ? '(护眼)' : '' }}</kye-radio> -->
                <kye-radio :label="theme.value">{{theme.label}}{{ theme.isEyeCare ? '(护眼)' : '' }}</kye-radio>
              </div>
              <div :style="{ backgroundImage: `url(${theme.url})` }" class="theme-color-preview"></div>
            </div>
          </div>
        </kye-radio-group>
      </div>
      <div class="theme-setting-drawer__body-item">
        <div class="theme-setting-drawer__body-item-title">对比度</div>
        <div class="theme-slider-container">
          <el-slider
            v-model="svgFilter"
            :show-tooltip="false"
            :min="contrastConfig[0]"
            :max="lastContrastConfigValue"
            :step="sliderStep"
            @change="changeSlider">
          </el-slider>
          <div class="theme-slider-value">
            <div v-for="(item , index) in contrastConfig" :style="{ left: index * 100 / contrastConfig.length + '%' }" :key="item" class="theme-slider-mark">
              <div class="theme-slider-mark-line"></div>
              <div class="theme-slider-mark-text">{{item}}</div>
            </div>
            <div class="theme-slider-mark" style="right: -2px;transform: none;">
              <div class="theme-slider-mark-line"></div>
              <div class="theme-slider-mark-text">{{lastContrastConfigValue}}</div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- <div class="theme-setting-drawer__footer">
      <div class="theme-setting-drawer__footer-btn" @click="saveTheme">
        <span>保存并应用</span>
        <img src="./images/right-arrow.png" />
      </div>
    </div> -->
  </kye-drawer>
</template>

<script>
import { BUILTIN_THEMES, DEFAULT_CONFIG, CONTRAST_CONFIG, REPORT_CONFIG } from '@/layout/layout/setup/theme-system/config'
import { themeSystem } from '@/layout/layout/setup/theme-system/index'
import AppearanceMode from '@/layout/components/appearance-mode.vue'
export default {
  components: { AppearanceMode },
  data() {
    return {
      visible: false,
      contrastConfig: CONTRAST_CONFIG.slice(0, -1),
      lastContrastConfigValue: CONTRAST_CONFIG.slice(-1)[0],
      // defaultConfig: DEFAULT_CONFIG,
      sliderStep: 0.5,
      currentMode: '',
      themeRadio: '',
      svgFilter: DEFAULT_CONFIG.contrast
    }
  },
  computed: {
    builtinThemes() {
      return BUILTIN_THEMES.filter(theme => theme.mode === this.currentMode)
    }
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        const config = themeSystem.getConfig() || {}
        const defaultTheme = BUILTIN_THEMES.find(item => item.value === DEFAULT_CONFIG.skinsCode).mode
        const theme = BUILTIN_THEMES.find(item => item.value === config.skinsCode)
        this.themeRadio = theme ? theme.value : defaultTheme.value
        this.currentMode = theme ? theme.mode : defaultTheme.mode
        this.svgFilter = config.contrast || DEFAULT_CONFIG.contrast
      }
    }
  },
  methods: {
    /**
     * 更改主题色，并实时保存
     * @param value
     */
    changeThemeRadio(value) {
      this.themeRadio = value
      themeSystem.saveConfig({ skinsCode: value, contrast: this.svgFilter })
      themeSystem.reportUserAction(REPORT_CONFIG.SKIN_FLAG)
    },
     /**
     * 更改对比度，并实时保存
     * @param value
     */
    changeSlider(value) {
      themeSystem.saveConfig({ skinsCode: this.themeRadio, contrast: value })
      themeSystem.reportUserAction(REPORT_CONFIG.CONTRAST_FLAG)
    },
    /**
     * 保存并应用主题色
     */
    saveTheme() {
      if (this.themeRadio) {
        themeSystem.saveConfig({ skinsCode: this.themeRadio, contrast: this.svgFilter })
        this.$message.success('保存成功')
        this.visible = false
        this.$emit('updateTheme', { skinsCode: this.themeRadio })
      } else {
        this.$message.warning('请选择主题色')
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.layout-theme-setting {
  /deep/ .theme-setting-drawer {
    min-width: 496px;
  }

  /deep/ .el-drawer__header {
    margin-bottom: 0;
    padding: 22px 28px 22px 24px;
    border-bottom: 1px solid rgba(231, 234, 236, 1);
    font-size: 20px;
    font-weight: 700;
    color: #453C5A;
  }

  /deep/ .el-drawer__close-btn {
    font-size: 16px;
    padding: 0;
    height: 16px;
    line-height: 16px;
  }

  /deep/ .el-drawer__body {
    position: relative;
  }

  .theme-setting-drawer__body {
    overflow-y: auto;
    height: 100%;
    padding: 12px 28px 12px 24px;

    &-item {
      padding: 12px 0;

      &-title {
        margin-bottom: 12px;
        // color: var(--g-theme-color-text);
        color: #453C5A;
        font-size: 14px;
        font-weight: 700;
      }

      .theme-color-container {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;
        .theme-color-item {
          display: flex;
          flex-direction: column;
          height: 96px;
          border-radius: 12px;
          border: 1px solid #E7EAEC;
          transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
          cursor: pointer;
          overflow: hidden;
          &.actived {
            border-color: #6d2ef8;
          }
          &:hover {
            border-color: #6d2ef8;
            /deep/ {
              .el-radio .el-radio__inner {
                border-color: #8b60f0;
              }
            }
          }
          .theme-color-radio {
            padding: 0 12px;
            height: 34px;
            display: flex;
            align-items: center;
            /deep/ .el-radio {
              width: 100%;
            }
            /deep/ .el-radio__label {
              font-size: 14px;
              color: #453C5A;
            }
          }
          .theme-color-preview {
            flex: 1;
            background-repeat: no-repeat;
            background-size: cover;
          }
        }
      }
      .theme-slider-container {
        border: 1px solid rgba(231, 234, 236, 1);
        border-radius: 12px;
        padding: 30px 24px;
        padding-bottom: 42px;
        height: 82px;
        /deep/ .el-slider__runway {
          margin-top: 0;
          margin-bottom: 0;
          height: 6px;
        }
        /deep/ .el-slider__button {
          width: 32px;
          height: 22px;
          border-radius: 20px;
          border: 1px solid rgba(226, 226, 241, 1);
          box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.12);
        }
      }
      .theme-slider-value {
        display: flex;
        position: relative;
        margin-top: 6px;
        .theme-slider-mark {
          text-align: left;
          position: absolute;
          transform: translateX(-50%);
          display: flex;
          flex-direction: column;
          align-items: center;
          .theme-slider-mark-line {
            width: 1px;
            height: 8px;
            background-color: rgba(232, 233, 238, 1);
          }
          .theme-slider-mark-text {
            margin-top: 4px;
            font-size: 12px;
            color: rgba(134, 130, 143, 1);
            font-weight: 500;
            line-height: 14px;
          }
        }
      }
    }
  }

  .theme-setting-drawer__footer {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    border-top: 1px solid rgba(231, 234, 236, 1);
    padding: 16px 32px;
    background-color: #fff;
    &-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 32px;
      width: 116px;
      background-color: #6C3CF4;
      color: #fff;
      font-size: 13px;
      border-radius: 224px;
      cursor: pointer;

      img {
        width: 12px;
        height: 12px;
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/theme2.vue